import {AfterViewInit, Component, Input, QueryList, ViewChildren} from '@angular/core';
import {PlaySportsDetailGridItemComponent} from './play-sports-detail-grid-item/play-sports-detail-grid-item.component';
import {PageNames} from '../../shared/page-names.enum';
import {NavigationService} from '../../services/navigation/navigation.service';
import {TvshopConstants} from '../../shared/tvshop-constants';
import {Environment} from '../../shared/environment/environment';
import {OmapiIdsUtils} from '../../shared/utils/omapi-ids/omapi-ids-utils';

@Component({
  selector: 'app-product-detail-offer',
  templateUrl: './product-detail-offer.component.html',
  styleUrls: ['./product-detail-offer.component.less']
})
export class ProductDetailOfferComponent implements AfterViewInit {
  @Input()
  omapiId: string;

  @Input()
  titleKey: string;

  @Input()
  descriptionKey: string;

  @ViewChildren(PlaySportsDetailGridItemComponent)
  sportsChildren: QueryList<PlaySportsDetailGridItemComponent>;

  sportsArray = [
    {name: 'football', active: false},
    {name: 'tennis', active: false},
    {name: 'golf', active: false},
    {name: 'volleyball', active: false},
    {name: 'racing', active: false},
    {name: 'cycling', active: false}
  ];
  private _bannerUrl: string;

  constructor(private navigationService: NavigationService) {
  }

  ngAfterViewInit() {
    this.navigationService.divideInRowsByElementPosition(PageNames.DETAIL_PAGE_OFFER, this.sportsChildren.toArray());
  }

  public get bannerUrl(): string {
    if (this._bannerUrl) {
      return this._bannerUrl;
    }
    return this.baseUrl() + TvshopConstants.IMAGES_AEM_PATH + OmapiIdsUtils.getCorrectIdForResource(this.omapiId) + '-' + this.sportsArray[0].name + '-banner.png';
  }

  public get backgroundImageUrl(): string {
    return this.baseUrl() + TvshopConstants.IMAGES_AEM_PATH + OmapiIdsUtils.getCorrectIdForResource(this.omapiId) + '-offer.jpg';
  }

  public changeBannerInfo(event) {
    this._bannerUrl = event.url;
  }

  private baseUrl(): string {
    return Environment.environmentConfig().baseUrl;
  }
}
